module.exports = __webpack_public_path__ + "media/images/help/line/heading-cta-f0bf36403c75b8968170f2688d737dba.svg";